import React from "react";
import { Box, Card, Typography } from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface UnusedObjectsSummaryProps {
  databaseCount: number;
  totalFindings: number;
}

const UnusedObjectsSummary: React.FC<UnusedObjectsSummaryProps> = ({
  databaseCount,
  totalFindings,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: 2,
        mb: 3,
      }}
    >
      <Card
        sx={{
          p: 2,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <StorageIcon />
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Total Databases
          </Typography>
        </Box>
        <Typography variant="h3" sx={{ fontWeight: 700 }}>
          {databaseCount}
        </Typography>
      </Card>

      <Card
        sx={{
          p: 2,
          background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <WarningAmberIcon />
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Total Findings
          </Typography>
        </Box>
        <Typography variant="h3" sx={{ fontWeight: 700 }}>
          {totalFindings}
        </Typography>
      </Card>
    </Box>
  );
};

export default UnusedObjectsSummary;
